"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrentBoardExamDate = void 0;
var _reactRedux = require("react-redux");
/* useCurrentBoardExamDate()
 *
 * Returns the current board exam date for the user.
 * Returns undefined if not found.
 */
var useCurrentBoardExamDate = function useCurrentBoardExamDate() {
  var session = (0, _reactRedux.useSelector)(function (state) {
    return state.session;
  });
  if (!session.get('is_logged_in')) return;
  var questionBankId = session.get('selected_question_bank_id');
  var boardExamDates = (0, _reactRedux.useSelector)(function (state) {
    return state.boardExamDates;
  });
  var selectedBoardExamDate = !!boardExamDates && boardExamDates.find(function (boardExamDate) {
    return boardExamDate.get('question_bank_id') === questionBankId;
  });
  return selectedBoardExamDate || undefined;
};
exports.useCurrentBoardExamDate = useCurrentBoardExamDate;